import { render, staticRenderFns } from "./OtherServiceIcons.vue?vue&type=template&id=b39be082&"
import script from "./OtherServiceIcons.vue?vue&type=script&lang=js&"
export * from "./OtherServiceIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports